import { render, staticRenderFns } from "./ChannelSelect.vue?vue&type=template&id=6705ef4e&scoped=true"
import script from "./ChannelSelect.vue?vue&type=script&lang=js"
export * from "./ChannelSelect.vue?vue&type=script&lang=js"
import style0 from "./ChannelSelect.vue?vue&type=style&index=0&id=6705ef4e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6705ef4e",
  null
  
)

export default component.exports